<template>
  <div>
    <el-dialog
      :close-on-click-modal= "false"
      :visible.sync="dialogShow"
      width="940px"
      :before-close="handleClose"
      @open="open"
    >
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane name="first">
          <span
            slot="label"
            style="display: flex; align-items: center; justify-content: center; "
          >
            <img
              src="../../../static/images/privilege_vip_icon.png"
              style="margin-right: 8px"
            />
            <span style="font-size:18px;">开通爱学术VIP</span>
          </span>
          <div class="content">
            <div class="content-body">
              <div class="account-info">
                <div>
                  <span>当前账号：</span>
                  <span style="margin-left: 10px">
                    {{ userScrollInfo.userName }}
                    <span v-if="!userScrollInfo.isVip">(非会员)</span>
                  </span>
                </div>
                <div>
                  <el-carousel
                    height="16px"
                    direction="vertical"
                    :autoplay="true"
                  >
                    <el-carousel-item
                      v-for="(item, index) in userScrollInfo.scroll"
                      :key="index"
                    >
                      <h3>
                        {{ item.name
                        }}<span style="color: #999999; margin: 0 13px">{{
                          item.time
                        }}</span
                        >{{ item.vip }}
                      </h3>
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
              <div class="config-info">
                <div>
                  <span>开通时长：</span>
                </div>
                <div class="config-info-option">
                  <div
                    v-for="(vipConfig, index) in vipConfigList"
                    :key="index"
                    :class="[
                      'option-item',
                      vipConfig.id == currentVipConfig.id ? 'is-active' : '',
                    ]"
                    @click="checkVipConfig(vipConfig)"
                  >
                    <div style="position:relative">
                      <img v-if="vipConfig.id == 4 " src="../../../static/images/privilege_vip_tag.png" style="position:absolute;top:-21px;left:-3px">
                      {{ vipConfig.name }}
                    </div>
                    <div class="price-info">{{ vipConfig.money }}元</div>
                    <div>{{ vipConfig.description }}</div>
                  </div>
                </div>
              </div>
              <div class="payment-method-info">
                <div>
                  <span>支付方式：</span>
                </div>
                <div class="method-info-option">
                  <div
                    v-for="(method, index) in payMethodList"
                    :key="index"
                    :class="[
                      'method',
                      method.code == currentPayMethod.code ? 'is-active' : '',
                    ]"
                    @click="changePayMethod(method)"
                  >
                    <div v-if="method.icon != ''">
                      <img
                        :src="method.icon"
                        style="margin-left: 18px; margin-right: 10px"
                      />
                      <span>{{ method.name }}</span>
                    </div>
                    <div
                      v-if="method.icon == ''"
                      style="
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                      "
                    >
                      <span>{{ method.name }}</span>
                      <span
                        >余额：<span style="color: #da521b">{{
                          userScrollInfo.userPoints
                        }}</span></span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="payment-info"
                v-if="currentPayMethod.code != 'points'"
              >
                <div
                  id="qrcode"
                  class="imgbox"
                  v-loading="loading"
                  @click="createVipOrder"
                ></div>
                <img
                  style="
                    width: 134px;
                    height: 134px;
                    position: absolute;
                    left: 165px;
                    top: 321px;
                  "
                  src="../../../static/images/lose.png"
                  alt=""
                  @click="codeImgC"
                  v-show="iscodeImg"
                />
                <div style="margin-left: 22px">
                  <div
                    style="
                      color: #da521b;
                      margin-top: 29px;
                      margin-bottom: 10px;
                    "
                  >
                    <span style="font-size: 34px; font-weight: bold">{{
                      orderInfo.money
                    }}</span
                    >元
                    （{{ currentVipConfig.discount }}）
                  </div>
                  <div>
                    {{ currentPayMethod.description }}
                  </div>
                </div>
              </div>
              <div
                class="payment-info"
                v-if="currentPayMethod.code == 'points'"
              >
                <span style="display: inline-block; height: 149px">
                  <button class="payment-info-btn" @click="immediatePay">
                    立即支付
                  </button>
                </span>
              </div>
            </div>
            <div class="content-footer">
              <p class="content-footer-title">
                <span>会员特权</span>
              </p>
              <div class="content-footer-body">
                <div
                  v-for="(item, index) in privileges"
                  :key="index"
                  class="privilege-item"
                >
                  <div style="position: relative">
                    <img
                      v-if="item.isNew"
                      src="../../../static/images/new.png"
                      style="position: absolute; left: 20px; top: -9px"
                    />
                    <img :src="item.icon" />
                  </div>
                  <span>{{ item.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane name="second">
          <span
            slot="label"
            style="display: flex; align-items: center; justify-content: center;"
          >
            <img
              src="../../../static/images/privilege_vip_money.png"
              style="margin-right: 8px"
            />
            <span style="font-size:18px;">学术币充值</span>
          </span>
          <div class="content">
            <div class="content-body">
              <div class="account-info">
                <div>
                  <span>当前余额：</span>
                  <span style="margin-left: 10px">
                    <span style="color: #da521b; font-weight: bold">{{
                      userInfo.points
                    }}</span>
                    <span style="color: #606266"
                      >({{ userInfo.pointsUseStr }})</span
                    >
                  </span>
                </div>
                <div style="width: 100px; margin-left: 260px">
                  <a
                    :href="userInfo.recordUrl"
                    target="_blank"
                    style="color: #606266; text-decoration: underline"
                    >充值记录</a
                  >
                </div>
              </div>
              <div class="config-info">
                <div>
                  <span style="padding-left:28px">充值：</span>
                </div>
                <div class="config-info-option">
                  <div
                    v-for="(rechargeConfig, index) in rechargeConfigList"
                    :key="index"
                    :class="[
                      'option-item',
                      rechargeConfig.id == currentRechargeConfig.id
                        ? 'is-active'
                        : '',
                    ]"
                    style="height:60px"
                    @click="checkRechargeConfig(rechargeConfig)"
                  >
                    <div class="recharge-price-info">
                      <span
                        :class="[
                          rechargeConfig.id == currentRechargeConfig.id
                            ? 'price-info'
                            : '',
                        ]"
                        style="font-size:16px"
                        >{{ rechargeConfig.name }}</span
                      >
                    </div>
                    <div>{{ rechargeConfig.money }}元</div>
                  </div>
                </div>
              </div>
              <div class="payment-method-info">
                <div>
                  <span>支付方式：</span>
                </div>
                <div class="method-info-option">
                  <div
                    v-for="(method, index) in payMethodList"
                    :key="index"
                    :class="[
                      'method',
                      method.code == currentPayMethod.code ? 'is-active' : '',
                    ]"
                    @click="changePayMethod(method)"
                  >
                    <div v-if="method.icon != ''">
                      <img
                        :src="method.icon"
                        style="margin-left: 18px; margin-right: 10px"
                      />
                      <span>{{ method.name }}</span>
                    </div>
                    <div
                      v-if="method.icon == ''"
                      style="
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                      "
                    >
                      <span>{{ method.name }}</span>
                      <span
                        >余额：<span style="color: #da521b">{{
                          userScrollInfo.userPoints
                        }}</span></span
                      >
                    </div>
                  </div>
                </div>
              </div>
              <div class="payment-info">
                <div
                  id="qrcodeRecharge"
                  class="imgbox"
                  v-loading="loadingRecharge"
                  @click="createRechargeOrder"
                ></div>
                <img
                  style="
                    width: 134px;
                    height: 134px;
                    position: absolute;
                    left: 165px;
                    top: 321px;
                  "
                  src="../../../static/images/lose.png"
                  alt=""
                  @click="codeImgC"
                  v-show="isRechargeCodeImg"
                />
                <div style="margin-left: 22px">
                  <div
                    style="
                      color: #da521b;
                      margin-top: 29px;
                      margin-bottom: 10px;
                    "
                  >
                    <span style="font-size: 34px; font-weight: bold">{{
                      currentRechargeConfig.money
                    }}</span
                    >元
                  </div>
                  <div>
                    {{ currentPayMethod.description }}
                  </div>
                </div>
              </div>
            </div>
            <div class="content-footer">
              <div class="content-footer-notice">
                <p>温馨提示：</p>
                <p />
                <p v-for="(notice, index) in notices" :key="index">
                  {{ notice }}
                </p>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
  </div>
</template>

<script>
import dataObj from "./data";
import QRCode from "qrcodejs2";
import account from "@/components/login/account";
export default {
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
    tabName: {
      type: String,
      default: 'first'
    }
  },
  data() {
    return {
      dialogShow: this.visible,
      activeName: this.tabName,
      vipConfigList: [],
      rechargeConfigList: [],
      userScrollInfo: {},
      privileges: [],
      payMethodList: [],
      notices: [],
      currentVipConfig: {},
      currentPayMethod: {},
      currentRechargeConfig: {},
      orderInfo: {},
      vipStateTime: {},
      rechargeOrderInfo: {},
      rechargeStateTime: {},
      userInfo: {},

      iscodeImg: false,
      loading: true,
      // 开通弹窗
      vipPop: false,
      loadingRecharge: true,
      isRechargeCodeImg: false,
    };
  },
  created() {
    // this.initData();
  },
  mounted() {

  },
  destroyed() {
    clearTimeout(this.vipStateTime);
    clearTimeout(this.rechargeStateTime);
  },
  methods: {
    open() {
      this.activeName = this.tabName;
      this.initData();
      if (this.activeName == 'second') {
        this.payMethodList = dataObj.payMethodList.slice(0, 2);
      }
    },
    initData() {
      this.secondTabInitData();
      this.firstTabInitData();
      this.getVipProduct();
      this.getVipUserScrollInfo();
      this.getRechargeConfig();
    },

    firstTabInitData() {
      this.privileges = dataObj.fullPrivilege;
      this.payMethodList = dataObj.payMethodList;
      this.currentPayMethod = this.payMethodList[0];
    },

    secondTabInitData() {
      this.notices = dataObj.notices;
      this.payMethodList = dataObj.payMethodList.slice(0, 2);
      this.currentPayMethod = this.payMethodList[0];
    },

    /** tab 切换 */
    handleClick(tab, event) {
      if (tab.name == "first") {
        this.firstTabInitData();
      } else if (tab.name == "second") {
        this.secondTabInitData();
      }
    },

    /** 切换vip配置 */
    checkVipConfig(config) {
      this.currentVipConfig = config;
      if (config.id <= 2) {
        this.privileges = dataObj.fullPrivilege.slice(
          2,
          dataObj.fullPrivilege.length
        );
      } else {
        this.privileges = dataObj.fullPrivilege;
      }
      clearTimeout(this.vipStateTime);
      this.createVipOrder();
    },
    /** 切换支付方式 */
    changePayMethod(method) {
      this.currentPayMethod = method;
    },

    /** 获取vip配置 */
    getVipProduct() {
      this.api.getVipProduct().then((res) => {
        if (res.code == 0) {
          this.vipConfigList = res.data;
          this.currentVipConfig = this.vipConfigList[0];
          this.createVipOrder();
        }
      });
    },
    /** 获取vip用户滚动信息 */
    getVipUserScrollInfo() {
      this.api.getVipUserScrollInfo().then((res) => {
        if (res.code == 0) {
          this.userScrollInfo = res.data;
        }
      });
    },
    /** 创建vip订单 */
    createVipOrder() {
      this.api
        .createVipOrder({
          configId: this.currentVipConfig.id,
        })
        .then((res) => {
          if (res.code == 0) {
            this.orderInfo = res.data;
            this.createQrcode("qrcode", this.orderInfo.url);
            //状态轮询
            clearTimeout(this.vipStateTime);
            this.vipStateTime = setInterval(function () {
              that.getVipOrderState();
            }, 3000);
            let that = this;
            // 90秒后二维码失效
            setTimeout(function () {
              if (document.getElementById("qrcode")) {
                document.getElementById("qrcode").innerHTML = "";
              }
              that.iscodeImg = true;
              clearTimeout(that.vipStateTime);
            }, 90000);
          } else {
            let that = this;
            // 服务器错误2秒后失效
            setTimeout(function () {
              that.loading = false;
              that.iscodeImg = true;
              clearTimeout(that.vipStateTime);
            }, 2000);
          }
        });
    },
    /** 获取vip订单状态 */
    getVipOrderState() {
      let that = this;
      this.api
        .getVipOrderState({
          orderId: this.orderInfo.orderId,
        })
        .then((res) => {
          if (res.code == 0) {
            if (res.data.isPay) {
              clearTimeout(that.vipStateTime);
              this.paySuccess();
            }
          }
        });
    },
    /** 学术币充值vip */
    immediatePay() {
      if (this.userScrollInfo.userPoints < this.currentVipConfig.money) {
        this.$message({
          message: "账户余额不足",
          type: "warning",
        });
        return;
      }
      this.api
        .pointPayOrder({
          configId: this.currentVipConfig.id,
        })
        .then((res) => {
          if (res.code == 0) {
            this.paySuccess();
          }
        });
    },

    /** 获取学术币信息列表 */
    getRechargeConfig() {
      this.api.getRechargeConfig().then((res) => {
        if (res.code == 0) {
          this.rechargeConfigList = res.data.configs;
          this.userInfo = res.data;
          this.currentRechargeConfig = this.rechargeConfigList[0];
          this.createRechargeOrder();
        }
      });
    },

    /** 切换学术币充值选项 */
    checkRechargeConfig(rechargeConfig) {
      this.currentRechargeConfig = rechargeConfig;
      this.createRechargeOrder();
    },

    /** 创建学术币充值订单 */
    createRechargeOrder() {
      this.api
        .createRechargeOrder({
          configId: this.currentRechargeConfig.id,
        })
        .then((res) => {
          if (res.code == 0) {
            this.rechargeOrderInfo = res.data;
            this.createQrcode("qrcodeRecharge", this.rechargeOrderInfo.url);
            //状态轮询
            clearTimeout(this.rechargeStateTime);
            this.rechargeStateTime = setInterval(function () {
              that.getRechargeOrderState();
            }, 3000);
            let that = this;
            // 90秒后二维码失效
            setTimeout(function () {
              if (document.getElementById("qrcodeRecharge")) {
                document.getElementById("qrcodeRecharge").innerHTML = "";
              }
              that.isRechargeCodeImg = true;
              clearTimeout(that.rechargeStateTime);
            }, 90000);
          } else {
            let that = this;
            // 服务器错误2秒后失效
            setTimeout(function () {
              that.loadingRecharge = false;
              that.isRechargeCodeImg = true;
              clearTimeout(that.rechargeStateTime);
            }, 2000);
          }
        });
    },
    /** 获取学术币充值订单状态 */
    getRechargeOrderState() {
      this.api
        .getRechargeOrderState({
          orderId: this.rechargeOrderInfo.orderId,
        })
        .then((res) => {
          let that = this;
          if (res.code == 0) {
            if (res.data.isPay) {
              console.log(111);
              clearTimeout(that.rechargeStateTime);
              this.paySuccess();
            }
          }
        });
    },
    /** 创建qrcode */
    createQrcode(element, url) {
      document.getElementById(element).innerHTML = "";
      let qrcode = new QRCode(element, {
        width: 120,
        height: 120,
        text: url, // 二维码地址
      });
    },
    codeImgC() {
      if (this.activeName == "first") {
        this.iscodeImg = false;
        this.createVipOrder();
      } else if (this.activeName == "second") {
        this.isRechargeCodeImg = false;
        this.createRechargeOrder();
      }
    },

    /** 支付成功之后的操作 */
    paySuccess() {
      this.$parent.paySuccess(true);
    },
    handleClose() {
      // this.$parent.closeRechargePop(false);
      this.$emit("update:visible", false);
    },
  },
  watch: {
    visible(val) {
      this.dialogShow = val;
    },
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-dialog__header{
  padding: 0;
  .el-dialog__headerbtn{
    top: 10px;
    right: 16px;
    z-index: 2000;
  }
}

/deep/ .el-dialog__body{
  padding: 0;
}

/deep/ .el-tabs__nav {
  display: flex;
  width: 940px;
  .el-tabs__item {
    border: none;
    text-align: center;
    width: 50%;
    height: 64px;
    line-height: 64px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    background: #f5f5f5;
  }
  /deep/ .el-tabs__item.is-active {
    background: #ffffff;
    font-weight: bold;
    color: #c7a46b;
  }
  .el-tabs__item:hover {
    color: #c7a46b;
  }
}

.content {
  background: #ffffff;
  .content-body {
    height: 485px;
    margin: 0 70px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    .account-info {
      display: flex;
      /deep/ .el-carousel__container {
        width: 280px;
        margin-left: 280px;
        font-size: 13px;
      }
    }
    .config-info {
      display: flex;
      .config-info-option {
        display: flex;
        .option-item {
          display: flex;
          flex-direction: column;
          justify-content: space-around;
          margin-left: 16px;
          width: 142px;
          height: 98px;
          text-align: center;
          border: 1px solid #dedede;
          cursor: pointer;
        }
        .price-info {
          color: #da521b;
          font-size: 18px;
          font-weight: 800;
        }
        .recharge-price-info {
          color: #333333;
          font-weight: 800;
          span {
            font-size: 18px;
          }
        }
        .is-active {
          border: 2px solid #cba76e;
          background: url("/static/images/privilege_vip_check.png") no-repeat
            bottom right;
        }
      }
    }
    .payment-method-info {
      display: flex;
      .method-info-option {
        display: flex;
        cursor: pointer;
        .method {
          margin-left: 16px;
          div {
            width: 142px;
            height: 46px;
            border: 1px solid #dedede;
            display: flex;
            align-items: center;
          }
        }
        .is-active {
          border: 2px solid #cba76e;
          background: url("/static/images/privilege_vip_check.png") no-repeat
            bottom right;
        }
      }
    }
    .payment-info {
      display: flex;
      .imgbox {
        width: 149px;
        height: 153px;
        margin-left: 87px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-image: url("/static/images/privilege_qrcode_bg.png");
        img {
          max-width: 41px;
        }
      }
      .payment-info-btn {
        width: 142px;
        height: 38px;
        margin-left: 86px;
        border: none;
        color: #ffffff;
        background: #f36b34;
        border-radius: 5px;
      }
    }
  }
  .content-footer {
    height: 196px;
    background: #fafafa;

    .content-footer-title {
      text-align: center;
      margin-bottom: 23px;
      span {
        display: inline-block;
        width: 93px;
        height: 14px;
        margin-top: 23px;
        font-size: 14px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #cba76e;
        background: url("/static/images/privilege_title_bg.png");
      }
    }
    .content-footer-body {
      display: flex;
      flex-wrap: wrap;
      //   justify-content: space-around;
      .privilege-item {
        width: 18%;
        height: 42px;
        margin-bottom: 24px;
        display: flex;
        align-items: center;
        span {
          margin-left: 12px;
        }
      }
      .privilege-item:nth-child(1),
      .privilege-item:nth-child(6) {
        margin-left: 70px;
      }
    }

    .content-footer-notice {
      position: relative;
      left: 86px;
      top: 23px;
      p {
        line-height: 24px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/recharge/rechargePop.vue